import React, {useCallback, useEffect, useState} from 'react';
import { Grid, GridContainer } from 'src/shared/grid';
import CheckIcon from '@mui/icons-material/Check';
import { createUpdateApiKey } from 'src/apis/mutationsApiKey';
import { errorResponse } from 'src/store/common';
import { useAddAlert} from 'src/store/actions';
import { useStoreContext } from 'src/store/context';
import { alertMessages } from 'src/constants';
import CloseIcon from '@mui/icons-material/Close';
import { continueStyleModal } from 'src/shared/Styles/Styles';
import { TextField, Button, Modal, IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import { ModalApiGen } from './ModalApiGen';

export const ApiGenAuth: React.FC = () =>{
    const [apiKey, setApiKey] = useState("Generate API Key");
    const [copied, setCopied] = useState(false);
    const [, dispatch] = useStoreContext();
    const addAlert = useAddAlert(dispatch);
    const [openCheckModal, setOpenCheckModal] = useState(false);
    const [cont, setCont] = useState(false);

    const handleAPIKeyCall = useCallback((params: any)=>{
        (async()=>{
            try{
                await createUpdateApiKey(params, addAlert);
            }   
            catch(error){
                errorResponse(error, addAlert, alertMessages.apiKey)
            }
        })();
    },[addAlert]);

    const generateApiKey = useCallback(() => {
        setCont(false);
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        const crypto = window.crypto;
        const values = new Uint8Array(64);
        crypto.getRandomValues(values);
        let key = '';
        for (let i=0; i<64;i++){
            key+= charSet[values[i] % charSet.length]
        }
        navigator.clipboard.writeText(key)
        setCopied(true)
        setApiKey(key);
        const paramToSend ={
            apiKey: key
        }
        handleAPIKeyCall(paramToSend);
        setOpenCheckModal(false)
    },[handleAPIKeyCall]);

    useEffect(()=>{
        if(cont){
            generateApiKey();
        }
    },[generateApiKey, cont])

    const onClickApiGen = useCallback(()=>{
        setCopied(false);
        setOpenCheckModal(true);
    },[])

    const handleCloseModal= (event, reason) => {
        if (reason && reason === "backdropClick") 
            return;
        setOpenCheckModal(false); 
      }
  return(
      <GridContainer className="margin-top-6">
          <Modal
              className="smooth-scrollbar"
              open={openCheckModal}
              onClose={handleCloseModal}
          >
              <div style={{ height: '100%' }}>
                  <IconButton aria-label='close' style={{ left: '75%', top: '29.5%', position: 'absolute', cursor: 'pointer' }} onClick={(e) => handleCloseModal(e, 'click')} >
                      <CloseIcon style={{ color: 'white' }} />
                  </IconButton>
                  <Box sx={continueStyleModal} className="smooth-scrollbar removePadding">
                    <ModalApiGen setCont={setCont} setOpenCheckModal={setOpenCheckModal}/>
                  </Box>
              </div>
          </Modal>
          <Grid row gap="md">
              <Grid
                  desktop={{ col: 12 }}
                  className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 padding-top-3">
                  <span className="font-sans-2xl text-bold">FEMS API Key Generator</span>
              </Grid>
              <Grid
                  desktop={{ col: 12 }}
                  className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 padding-top-3">
                  To generate a FEMS API key, click the Generate New API Key button. You can then copy and save the API key for use in your application.
              </Grid>
          </Grid>

          <div>
              <div style={{paddingBottom: '2rem'}}>
                  <span className="font-sans-md">Username: { JSON.parse(localStorage.getItem('user') ??'{"userInfo":{"firstName": "John", "lastName":"Smith", "email":"","appRoles": null}}').userInfo.email}</span>
              </div>
              <TextField id="outlined-basic" label="Api Key Generator" variant="outlined"
                  style={{width: '100%', paddingBottom:'2rem'}}
                  defaultValue="Generate API Key"
                  value={apiKey}
                  aria-readonly
                  InputProps={{
                      readOnly: true,
                  }}
              />
             
          </div>

          <Grid row gap="sm">
              <Grid
                  desktop={{ col: 9 }}
                  className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 padding-top-3">
              </Grid>
              <Grid
                  desktop={{ col: 1}}
                  className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 padding-top-3">
                <Grid>
                      {copied &&
                          <>
                              <CheckIcon />
                              <span>Copied</span>
                          </>
                      }
                </Grid>
              </Grid>
              <Grid
                  desktop={{ col: 2}}
                  className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 padding-top-3">
                   <Button variant="contained"
                    onClick={()=>onClickApiGen()}

                   >Generate API Key</Button>
              </Grid>
          </Grid>
      </GridContainer>
  )
}